import composer from '@/composers';
import { POST_LOADER_DELAY } from '@/constants';
import auth from '@/services/auth';

/*
  This composition calls fetchData
  on route change and mount

  REQUIRED:
    - data.fetched
    - methods.fetchData (must return promise)
*/

export const component = (
  view: IView,
) => composer({
  mergeFunction: {
    created: {
      where: 'after',
      cb(this: any) {
        this.fetched = false;
        this.fetchOnRouteChange = true;
      },
    },
    mounted: {
      where: 'before',
      cb(this: any) {
        const { params } = this.$route;
        const [recordIdParam] = Object
          .keys(params)
          .filter(key => key.includes('Id'));

        if (params[recordIdParam] === 'create' && this.createRecord) {
          this.createRecord();
        } else {
          this.fetched = false;
          this.fetchFromRoute();
        }
      },
    },
  },
  methods: {
    fetchFromRoute() {
      if (this.fetchOnRouteChange !== true) {
        return;
      }
      const dashboardAction = {
        text: 'Go to dashboard',
        click: () => this.$router.push({
          name: 'dashboard',
        }),
      };
      const homepageAction = {
        text: 'Back to homepage',
        click: () => {
          window.location.href = '/';
        },
      };

      const promise = this.fetchData().then(
        () => setTimeout(() => this.fetched = true, POST_LOADER_DELAY),
        (error: any = {}) => {
          console.error(error);

          const [, parentName, childName] = this.$route.fullPath.split('/');
          const userLoggedIn = !!auth.getCurrentToken();
          let secondaryButton;

          if (!userLoggedIn) {
            // go to homepage
            secondaryButton = homepageAction;
          } else if (childName) {
            // go to parent page
            secondaryButton = {
              text: `View all ${parentName}`,
              click: (dialog: any) => {
                dialog.close();
                this.$router.push({
                  name: parentName,
                });
              },
            };
          } else {
            // go back to dashboard
            secondaryButton = dashboardAction;
          }

          this.$store.commit('dialog/CREATE', {
            title: 'Load error',
            content: `
              We experienced an error while loading
              the ${this.$route.name}.
              Please reload this page and try again.
            `,
            delay: POST_LOADER_DELAY,
            compact: true,
            buttons: [{
              text: 'Try again',
              click: () => this.$router.go(),
            }, secondaryButton],
          });

          throw error;
      });

      this.$store.commit('loader/ADD', {
        title: 'Fetching data',
        promise,
      });
    },
  },
  watch: {
    $route: 'fetchFromRoute',
  },
}, view);
